import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _flow from 'lodash/flow';
import _curryRight from 'lodash/curryRight';
import _property from 'lodash/property';
import { formatCurrency } from '@tekion/tekion-base/formatters/formatCurrency';
import Money from '@tekion/tekion-base/utils/money';
export var onlyInitials = function onlyInitials() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var string = '';
  var words = str.split(' ');
  if (words.length > 1) {
    string = "".concat(words[0][0]).concat(words[words.length - 1][0]);
  } else {
    string = "".concat(words[0][0]);
  }
  return string.toUpperCase();
};
export var arrayGroup = function arrayGroup(array, key) {
  var store = {};
  array.forEach(function (entry) {
    var category = entry[key];
    if (!store[category]) {
      store[category] = [entry];
    } else {
      store[category].push(entry);
    }
  });
  return store;
};
export var uniqueId = function uniqueId() {
  return Math.random();
};
export var isScrollParentRefValid = function isScrollParentRefValid(scrollParentRef) {
  var currentDOMElement = _get(scrollParentRef, 'current');
  return !_isEmpty(currentDOMElement);
};
export var getFormattedAmount = _flow([_curryRight(Money.format)({
  isInt: true
}), formatCurrency]);
export var uuid = function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0; // eslint-disable-line
    var v = c == 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
    return v.toString(16);
  });
};
export var getResponse = _property('data.data');